import { csrfTokenService } from '../csrf/CsrfTokenService'
import { injectable } from '~/container'
import { langFallbackFetch } from '~/lang/utils/langfetch'
import { IsoDateFormatter } from '~/utility/date/IsoDateFormatter'
import { AddReviewRepository } from './repositories'
import { ReviewFormData } from './types'

@injectable()
export class AddReviewRepositoryFetch extends AddReviewRepository {
  async create(
    campsiteSlug: string,
    reviewFormData: ReviewFormData,
    token: string,
    langCode: string,
  ): Promise<{ id: string }> {
    console.log('addReview request', JSON.stringify(reviewFormData))
    const response = await this.getResponse(
      campsiteSlug,
      reviewFormData,
      token,
      langCode,
    )
    const data = await response.json()
    console.log('addReview response', JSON.stringify(data))
    if (!response.ok) {
      throw data
    }
    return { id: data.id.toString() }
  }

  private async getResponse(
    campsiteSlug: string,
    reviewFormData: ReviewFormData,
    token: string,
    langCode: string,
  ) {
    const { csrfToken } = await csrfTokenService()
    return langFallbackFetch(
      langCode,
      `/reviews/post-review/campsite/${campsiteSlug}/?format=json`,
      {
        method: 'POST',
        headers: {
          'X-ELDARION-AJAX': 'true',
          'X-CSRFToken': csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: this.getFormData(reviewFormData, token),
      },
    )
  }

  private getFormData(data: ReviewFormData, token: string) {
    const formData = new FormData()
    formData.append('verify', token)
    formData.append('rate_overall', data.overallRate.toString())
    formData.append('group_type', data.travellingAs)
    formData.append('unit_type', data.stayedIn)
    formData.append('visit_date', this.getFormDataVisitDate(data.visitDate))
    formData.append('liked', data.liked)
    formData.append('disliked', data.disliked)
    formData.append('title', data.summary)
    formData.append('rate_location', data.rateLocation.toString())
    formData.append('rate_value', data.rateValue.toString())
    formData.append('rate_quality', data.rateAccomodation.toString())
    formData.append('rate_facilities', data.rateFacilities.toString())
    formData.append('rate_service', data.rateService.toString())
    formData.append('rate_child_friendly', data.rateChildFriendly.toString())
    formData.append('rate_clean', data.rateClean.toString())
    formData.append('rate_wifi', data.rateWifi.toString())
    data.theme.forEach((theme) => {
      formData.append('themes', theme)
    })
    formData.append('recommend', data.recommendToAFriend ? 'True' : 'False')
    formData.append('revisit', data.willYouReturn ? 'True' : 'False')
    formData.append('is_anonymous', data.anonymous ? 'on' : '')
    return formData
  }

  private getFormDataVisitDate(visitDate: string) {
    const newVisitDate = new Date(visitDate)
    newVisitDate.setDate(1)
    return IsoDateFormatter.toIsoDate(newVisitDate)
  }
}
